import { useLocation, useNavigate } from 'react-router-dom';
import { scroller } from 'react-scroll';

export function scrollToSection(sectionId, offset = -150) {
  scroller.scrollTo(sectionId, {
    smooth: true,
    duration: 500,
    offset,
  });
}

export default function NavSectionLink({ to, children, onClick, offset = -150, className }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    onClick?.(e);

    if (location.pathname === '/') {
      scrollToSection(to, offset);
      return;
    }

    navigate('/', { state: { scrollTo: to, scrollOffset: offset } });
  };

  return (
    <a href={`/#${to}`} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
